export default __webpack_public_path__ + "static/bv-web-79dfa0fb3539582d54e7b725ffe72b74.png";